export class ProductType {

    public id: number;
    public Type: string;
}